module.exports = __webpack_public_path__ + "f0c2e74ddf5156193480b0e2d483a3e3.svg";